import api from "../../components/api"
import { GpsLog } from '../../components/maps/GpsLog'
import { UnbillableTime, UnbillableTimeWithBreakDeduction, UnbillableVisit } from './timeTrackingPeriod'

export const getUnbillablePeriod = async (periodId: string): Promise<UnbillableTimeWithBreakDeduction> => {
  return (await api.get(`/web/time-tracking/unbillable/${periodId}`)).data
}

export const getUnbillablePeriodGpsLog = async (periodId: string): Promise<GpsLog[]> => {
  return (await api.get(`/web/time-tracking/unbillable/${periodId}/gps`)).data
}

export const updateUnbillablePeriodAsync = async (period: UnbillableTime, submit?: boolean): Promise<void> => {
  return await api.post(`/web/time-tracking/unbillable${submit ? '/submit' : ''}`, period)
}

export type AddUnbillablePeriodsRequest = {
  foremanId: string
  crewMemberIds: number[]
  unbillableCategoryId: string
  startUtc: string
  endUtc: string
  lunch: number
}
export const addUnbillablePeriodsAsync = async (periods: AddUnbillablePeriodsRequest, submit?: boolean): Promise<void> => {
  return await api.post(`/web/time-tracking/unbillable/create?submit=${submit ? 'true' : 'false'}`, periods)
}

export const deleteUnbillablePeriodAsync = async (periodId: string): Promise<void> => {
  return await api.delete(`/web/time-tracking/unbillable/${periodId}`)
}

export const visitHasTimeEntries = async (visitId: string): Promise<boolean> => {
  return (await api.get(`/web/time-tracking/visits/${visitId}/has-time-entries`)).data.hasTimeEntries
}

export const getUnbillableVisit = async (visitId: string): Promise<UnbillableVisit> => {
  return (await api.get(`/web/unbillable-visits/${visitId}`)).data
}

export const updateUnbillableVisitNotes = async (visitId: string, notes: string | undefined): Promise<void> => {
  return await api.put(`/web/unbillable-visits/${visitId}/notes`, { notes })
}